import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarTypeView } from 'primeng/calendar';

@Component({
	selector: 'cv-datepicker-two',
	templateUrl: './datepicker-two.component.html',
	styleUrls: ['./datepicker-two.component.scss'],
})
export class DatepickerTwoComponent implements OnInit {
	@Input() value: Date;
	@Input() minDate: Date;
	@Input() maxDate: Date;
	@Input() disabledDates: Date[];
	@Input() disabledDays: number[];
	@Input() numberOfMonths: number;
	@Input() placeholder: string;
	@Input() inputId: string;
	@Input() ariaLabelledBy: string;
	@Input() iconAriaLabel: string;
	@Input() name: string;
	@Input() dateFormat: string;
	@Input() icon: string;
	@Input() selectionMode: string;
	@Input() hourFormat: string;
	@Input() maxDateCount: number;
	@Input() width: number;
	@Input() disabled: boolean;
	@Input() required: boolean;
	@Input() valid: boolean;
	@Input() inline: boolean;
	@Input() touchUI: boolean;
	@Input() showButtonBar: boolean;
	@Input() showWeekNumbers: boolean;
	@Input() showOtherMonths: boolean;
	@Input() showTime: boolean;
	@Input() stepHour: number;
	@Input() stepMinute: number;
	@Input() stepSecond: number;
	@Input() showSeconds: boolean;
	@Input() timeOnly: boolean;
	@Input() timeSeparator: string;
	@Input() multipleSeparator: string;
	@Input() rangeSeparator: string;
	@Input() selectOtherMonths: boolean;
	@Input() showClear: boolean;
	@Input() view: CalendarTypeView;
	@Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
	constructor() {
		this.showButtonBar = false;
		this.required = false;
		this.numberOfMonths = 1;
		this.view = 'date';
		this.valid = true;
		this.showOtherMonths = true;
		if(!this.selectionMode){
			this.selectionMode = 'single';
		}

	}

	ngOnInit(): void {
		if (this.value) {
			this.showClear = true;
		}
	}

	/**
	 * Clears out the current value (to null)
	 */
	clearValue(): void {
		this.showClear = false;
		this.value = null;
		this.onValueChange(null);
	}

	/**
	 * Emits the valueChange event with the current value.
	 * @param $event: any
	 */
	onValueChange($event: any): void {
		this.valueChange.emit($event);
		this.showClear = true;
	}
}
